import queryString from 'query-string'
import { usingGet, EMPTY_SUCCESS_RESPONSE } from '@ocean/api'
import { FilterUtils } from '@ocean/utils'
import { ElearningCategoryFilterItems } from 'modules/trainingLibrary/Elearning/types'

export const getTrainingLibraryOverview = (externalFilters: ElearningCategoryFilterItems) => {
  const filterValues = FilterUtils.getExternalFilterValues(externalFilters)
  if (FilterUtils.findEmptyFilter(filterValues)) return EMPTY_SUCCESS_RESPONSE
  const queryParams = queryString.stringify(filterValues, { skipNull: true })
  return usingGet(`Search/Library/Overview?${queryParams}`, { useProxy: true })
}
